import { AppNS } from 'app';
import { RootState } from 'app/store/rootReducer';
import BellIcon from 'app/ui/icons/BellIcon';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Box, IconButton, SxProps, Tooltip } from '@mui/material';

export interface MessagesBellProps {
  userRole: AppNS.Role;
}

const getStyles = (): { [key: string]: SxProps } => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      height: '64px',
      width: '40px',
      position: 'relative',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      height: '64px',
      width: '100%',
      padding: 0,
      minWidth: '40px',
      borderRadius: 0,
    },
    unreadCounter: {
      position: 'absolute',
      right: 0,
      top: '12px',
      width: '17px',
      height: '17px',
      borderRadius: '8px',
      zIndex: 10,
      background: '#c72f66',
      fontSize: '1.2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
    },
    activeMark: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      height: '4px',
      borderRadius: '2px',
      background: '#ad3838',
    },
  };
};

export default function MessagesBell(props: MessagesBellProps) {
  const { userRole } = props;
  const { unreadCount, isMessagingPageOn } = useSelector((state: RootState) => state.messaging);

  const styles = getStyles();

  const prefix = userRole === 'admin' ? 'backoffice' : userRole;

  return (
    <Tooltip title="Messages">
      <Box sx={styles.root}>
        <IconButton sx={styles.button} component={Link} to={`/${prefix}/messaging/inbox`}>
          <BellIcon />
          {unreadCount > 0 && <Box sx={styles.unreadCounter}>{unreadCount}</Box>}
        </IconButton>
        {isMessagingPageOn > 0 && <Box sx={styles.activeMark}></Box>}
      </Box>
    </Tooltip>
  );
}
